<template>
  <div class="main-wrapper">

    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <a class="text-lg" href="/" style="font-size: 26px">
                    <span class="font-weight-600 text-slate-300" style="color:#1f2937;">{{
                        $t("logo.prefix")
                      }} </span><span class="font-weight-bold text-slate-500"
                                      style="color: #fff; font-weight: bold; background-color: #004A59; padding: 6px; border-radius: 5px">{{
                      $t("logo.suffix")
                    }}</span>
                  </a>
                </router-link>
              </div>
            </div>
            <div class="login-header text-center">
              <h5 class="text-muted">Please verify your email</h5>
              <div class="mt-4">
                <div class="alert alert-info">
                  <p>We have sent you a verification link to your email, click it or enter code below to continue</p>
                </div>
              </div>
            </div>
          </div>

          <form action="">
            <div class="form-group mb-4">
              <input
                id="token"
                v-model="token"
                class="form-control"
                name="token"
                placeholder="Enter your code"
                required
                type="text"
              />
            </div>
            <div class="text-center">
              <button class="btn btn-primary btn-block account-btn" type="button" @click="verifyAccount()">Verify
              </button>
              <button class="btn btn-primary btn-block account-btn" style="background-color: white; color: black"
                      type="button"
                      @click="login()">Login
              </button>
            </div>
          </form>
          <div class="login-or">
            <span class="or-line"></span>
            <span class="span-or">or</span>
          </div>
          <div class="text-center dont-have">Didn't get or expired?
            <router-link to="/register/resend-code">Resend Code</router-link>
          </div>
          <div class="text-center dont-have">
            <div>
              <small id="terms-footnote" class="footnote">
                By continuing, you confirm you have read and agree to the <a href="https://salesdue.com/privacy">privacy
                policy</a> and <a href="https://salesdue.com">terms and conditions</a> that govern your usage of
                FastaText services.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authServiceApi from "../../service/AuthServiceApi.js"
import {handleError} from "../../utils/notification.utils";

export default {
  name: "register-user",
  data() {
    return {
      token: null
    };
  },
  methods: {
    login() {
      this.$router.push('/login');
    },
    verifyAccount() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      let data = {
        token: this.token,
        domain: location.host,
        locale: Intl.NumberFormat().resolvedOptions().locale
      }
      authServiceApi.verifyAccount(data)
        .then(response => {
          if (response.data.success) {
            localStorage.setItem("showFreebiesPopUp", "true")
            this.resetMessage()
            this.fireNotification("success", 'Success', response.data.narrative)
            localStorage.clear();
            this.$router.push("/login")
            return
          }
          this.fireNotification("warning", 'Bad Request!', response.data.narrative)
        })
        .catch(e => {
          handleError(e);
        }).finally(() => {
        loader.hide()
      })
    },
    resetMessage() {
      this.token = null
    },
    fireNotification(icon, title, message) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
        footer: '<a href="">Need help?</a>'
      })
    },
  },
  mounted() {
    this.token = this.$route.query.token;
    if (this.token) {
      this.verifyAccount()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/ConfirmAccount.vue